export const ERROR_MODAL_QUERY_STRING_PARAM = 'error';
